import React, { useState, useEffect } from 'react';
import md5 from 'crypto-js/md5';
import { PiUserLight, PiBuildingLight } from 'react-icons/pi';

interface ClientAvatarProps {
  email: string;
  name: string;
  clientType: 'Individual' | 'Business';
  companyLogo?: string;
}

const ClientAvatar: React.FC<ClientAvatarProps> = ({ email, name, clientType, companyLogo }) => {
  const [useGravatar, setUseGravatar] = useState(false);
  const [gravatarLoaded, setGravatarLoaded] = useState(false);

  useEffect(() => {
    if (clientType === 'Individual' && email) {
      const gravatarUrl = `https://www.gravatar.com/avatar/${md5(email.toLowerCase().trim())}?s=40&d=404`;
      const img = new Image();
      img.onload = () => {
        setUseGravatar(true);
        setGravatarLoaded(true);
      };
      img.onerror = () => {
        setUseGravatar(false);
        setGravatarLoaded(true);
      };
      img.src = gravatarUrl;
    } else {
      setGravatarLoaded(true);
    }
  }, [email, clientType]);

  if (!gravatarLoaded) {
    return <div className="w-10 h-10 rounded-full bg-gray-200 animate-pulse" />;
  }

  if (clientType === 'Business') {
    if (companyLogo) {
      return (
        <img
          src={companyLogo}
          alt={`${name}'s Logo`}
          className="w-10 h-10 rounded-full object-cover"
        />
      );
    } else {
      return (
        <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center">
          <PiBuildingLight className="text-gray-500" size={20} />
        </div>
      );
    }
  } else if (useGravatar && email) {
    const gravatarUrl = `https://www.gravatar.com/avatar/${md5(email.toLowerCase().trim())}?s=40&d=404`;
    return (
      <img
        src={gravatarUrl}
        alt={`${name}'s Avatar`}
        className="w-10 h-10 rounded-full object-cover"
      />
    );
  } else {
    return (
      <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center">
        <PiUserLight className="text-gray-500" size={20} />
      </div>
    );
  }
};

export default ClientAvatar;